export default {
  opened: true,
  isMobile: false
}
